import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { trackInitiateCheckout } from '../lib/metaPixel';
type PurchaseButtonProps = {
  children: React.ReactNode;
  className?: string;
  href?: string;
};
type NavigatorWithConnection = Navigator & {
  connection?: {
    saveData?: boolean;
  };
};
const DEFAULT_CHECKOUT_URL = 'https://www.avanzapro.store/cart/48591077441761:1';
export function PurchaseButton({
  children,
  className = '',
  href = DEFAULT_CHECKOUT_URL
}: PurchaseButtonProps) {
  const prefersReducedMotion = useReducedMotion();
  const [saveData, setSaveData] = useState(false);
  useEffect(() => {
    const navigatorWithConnection = navigator as NavigatorWithConnection;
    setSaveData(Boolean(navigatorWithConnection.connection?.saveData));
  }, []);
  const shouldAnimate = !prefersReducedMotion && !saveData;
  return <motion.a href={href} onClick={trackInitiateCheckout} whileInView={shouldAnimate ? {
    scale: [1, 1.018, 1]
  } : undefined} viewport={{
    amount: 0.7
  }} transition={shouldAnimate ? {
    duration: 2.8,
    repeat: Infinity,
    ease: 'easeInOut'
  } : undefined} whileHover={shouldAnimate ? {
    scale: 1.035
  } : undefined} whileTap={{
    scale: 0.98
  }} className={`inline-flex min-h-14 max-w-full items-center justify-center gap-2 rounded-full bg-amber-400 px-6 py-3 text-center text-sm font-black leading-5 text-emerald-950 shadow-lg shadow-amber-950/20 focus:outline-none focus:ring-4 focus:ring-amber-200 sm:min-h-[3.75rem] ${className}`} data-id="element-13">
      <span data-id="element-14">{children}</span>
      <ArrowRightIcon size={18} className="shrink-0" aria-hidden="true" data-id="element-15" />
    </motion.a>;
}